<template>
   <div id="wrap-menu" class="d-flex align-items-center">
        <div id="sub-menu" :class="{open: hidden}">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SubMenuIcon',
    data(){
        return{
            hidden: Boolean,  
        }
    },
    props:['isHidden'],
    created(){
        this.hidden=false;
    },
    watch:{
        isHidden(va1,va2){
            this.hidden=va1;
        }
    }
}
</script>

<style lang="scss" scope>
#sub-menu{
  width: 30px;
  height: 35px;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor:pointer;
}

#sub-menu span{
  display: block;
  position: absolute;
  height: 5px;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;

}

#sub-menu span:nth-child(1){
  top: 6px;
}

#sub-menu span:nth-child(2), #sub-menu span:nth-child(3){
  top: 15px;
}

#sub-menu span:nth-child(4){
  top: 24px;
}

#sub-menu.open span:nth-child(1){
  top: 18px;
  width: 0%;
  left: 50%;
}

#sub-menu.open span:nth-child(2){
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#sub-menu.open span:nth-child(3){
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#sub-menu.open span:nth-child(4){
  top: 18px;
  width: 0%;
  left: 50%;
}
</style>